module.exports = __webpack_public_path__ + "static/media/color_blind_image_8.6a84e14f.jpg";